<script>
  import { onMount } from "svelte";

  let data = [];

  onMount(async function() {
    const response = await fetch("https://www.tauramena.com/wp-json/wp/v2/posts?filter[order]=rand&filter[posts_per_page]=3");
    const json = await response.json();
    data = json;
  });
</script>

<ul>
  {#each data as link}
    <li>
      <!-- <a href={link.url}>{link.title.rendered}</a> -->
      <h2> Post id: {link.id} </h2>
      <h3> { @html link.content.rendered} </h3>
    </li>
  {/each}
</ul>